import React from "react";

const GoogleVerificationPage = () => {
    return (
        <div style={{ whiteSpace: "pre-wrap", fontFamily: "monospace" }}>
            google-site-verification: google4d4bf5e7f22bdd3e.html
        </div>
    );
};

export default GoogleVerificationPage;
